import { RootState } from '../../../config/redux/store';
import { IAuthenticationSlice } from './type';

export const selectAuthState = (state: RootState): IAuthenticationSlice =>
	state.auth;

export const selectUser = (state: RootState): any =>
	state;
